import React from 'react';
import { useTranslation } from 'react-i18next';
import './Page.css';
import './Koncerty.css';

const Koncerty = () => {
  const { t } = useTranslation();
  
  const upcomingConcerts = [
    {
      id: 1,
      date: '2024-03-15',
      time: '19:00',
      venue: 'Teatr Wielki - Opera Narodowa',
      city: 'Warszawa',
      program: 'Gala Operowa - Arie z oper Verdiego',
      conductor: 'Jacek Kaspszyk',
      orchestra: 'Orkiestra Opery Narodowej',
      ticketInfo: 'Bilety dostępne na stronie teatru'
    },
    {
      id: 2,
      date: '2024-04-22',
      time: '18:30',
      venue: 'Filharmonia Narodowa',
      city: 'Warszawa',
      program: 'Koncert Chopinowski - Pieśni polskie',
      conductor: 'Michał Dworzyński',
      orchestra: 'Orkiestra Filharmonii Narodowej',
      ticketInfo: 'Bilety od 50 zł'
    },
    {
      id: 3,
      date: '2024-05-10',
      time: '20:00',
      venue: 'Teatr Muzyczny Capitol',
      city: 'Wrocław',
      program: 'Recital wokalny - Muzyka francuska',
      conductor: 'Solo z akompaniamentem fortepianu',
      orchestra: 'Marcin Sikorski - fortepian',
      ticketInfo: 'Bilety dostępne w kasie teatru'
    },
    {
      id: 4,
      date: '2024-06-05',
      time: '19:30',
      venue: 'Opera Krakowska',
      city: 'Kraków',
      program: 'La Traviata - Violetta',
      conductor: 'Tomasz Tokarczyk',
      orchestra: 'Orkiestra Opery Krakowskiej',
      ticketInfo: 'Premiera sezonu 2024/25'
    }
  ];

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('pl-PL', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="page">
      <div className="page-container">
        <div className="page-header">
          <h1>{t('concerts.title')}</h1>
          <p className="page-subtitle">{t('concerts.subtitle')}</p>
        </div>
        
        <div className="page-content">
          <div className="concerts-intro">
            <p>
              {t('concerts.intro')}
            </p>
          </div>

          <div className="concerts-list">
            {upcomingConcerts.map((concert) => (
              <div key={concert.id} className="concert-card">
                <div className="concert-date">
                  <div className="date-day">
                    {new Date(concert.date).getDate()}
                  </div>
                  <div className="date-month">
                    {new Date(concert.date).toLocaleDateString('pl-PL', { month: 'short' })}
                  </div>
                </div>
                
                <div className="concert-details">
                  <h3 className="concert-program">{concert.program}</h3>
                  <div className="concert-info">
                    <div className="info-item">
                      <strong>{t('concerts.date')}:</strong> {formatDate(concert.date)}
                    </div>
                    <div className="info-item">
                      <strong>{t('concerts.time')}:</strong> {concert.time}
                    </div>
                    <div className="info-item">
                      <strong>{t('concerts.venue')}:</strong> {concert.venue}
                    </div>
                    <div className="info-item">
                      <strong>{t('concerts.city')}:</strong> {concert.city}
                    </div>
                    <div className="info-item">
                      <strong>{t('concerts.conductor')}:</strong> {concert.conductor}
                    </div>
                    <div className="info-item">
                      <strong>{t('concerts.orchestra')}:</strong> {concert.orchestra}
                    </div>
                    <div className="info-item ticket-info">
                      <strong>{t('concerts.tickets')}:</strong> {concert.ticketInfo}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="concerts-note">
            <h3>{t('concerts.additionalInfo')}</h3>
            <p>
              {t('concerts.additionalInfoText1')}
            </p>
            <p>
              {t('concerts.additionalInfoText2')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Koncerty;
